import { lazy } from 'react';

export const LazyDropboxRequestStorageAccessPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--dropbox-request-storage-access-page" */ './dropbox-request-storage-access-page'
    ),
);
